import { render, staticRenderFns } from "./Another.vue?vue&type=template&id=c3e2a92a&scoped=true&"
import script from "./Another.vue?vue&type=script&lang=js&"
export * from "./Another.vue?vue&type=script&lang=js&"
import style0 from "./Another.vue?vue&type=style&index=0&id=c3e2a92a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e2a92a",
  null
  
)

component.options.__file = "Another.vue"
export default component.exports